module.exports = "/static/media/article05.d468cbce.jpg";